import React from 'react'
import { Circle, Group } from 'react-konva'
import { toScale } from '../../../lib/canvas-math.js'

const ZoneCircle = ({ pubgMapSize, mapSize, mapScale, circle, color, background }) => {
    const scaledX = toScale(pubgMapSize, mapSize, circle.x)
    const scaledY = toScale(pubgMapSize, mapSize, circle.y)
    const scaledRadius = toScale(pubgMapSize, mapSize, circle.radius)

    return (
        <Circle
            x={scaledX}
            y={scaledY}
            fill={background}
            stroke={color}
            radius={scaledRadius}
            strokeWidth={2 / mapScale}
        />
    )
}

const BlueZone = ({ pubgMapSize, mapSize, mapScale, circle, safeCircle }) => {
    const scaledX = toScale(pubgMapSize, mapSize, circle.x)
    const scaledY = toScale(pubgMapSize, mapSize, circle.y)
    const scaledRadius = toScale(pubgMapSize, mapSize, circle.radius)

    const scaledSafeX = safeCircle ? toScale(pubgMapSize, mapSize, safeCircle.x) : 0
    const scaledSafeY = safeCircle ? toScale(pubgMapSize, mapSize, safeCircle.y) : 0
    const scaledSafeRadius = safeCircle ? toScale(pubgMapSize, mapSize, safeCircle.radius) : 0

    const showBlueBackground = scaledRadius < mapSize * Math.sqrt(2) / 2 &&
                               (safeCircle ? scaledRadius > scaledSafeRadius : true)

    // Calculate the diagonal of the map to ensure full coverage
    const mapDiagonal = Math.sqrt(2 * Math.pow(mapSize, 2))

    return (
        <Group>
            {showBlueBackground && (
                <React.Fragment>
                    <Circle
                        x={mapSize / 2}
                        y={mapSize / 2}
                        radius={mapDiagonal / 2}
                        fill="#4259fa66"
                    />
                    <Circle
                        x={scaledX}
                        y={scaledY}
                        radius={scaledRadius}
                        fill="white"
                        globalCompositeOperation="destination-out"
                    />
                </React.Fragment>
            )}
            <Circle
                x={scaledX}
                y={scaledY}
                radius={scaledRadius}
                stroke="#4259FA"
                strokeWidth={2 / mapScale}
            />
            {safeCircle && (
                <Circle
                    x={scaledSafeX}
                    y={scaledSafeY}
                    radius={scaledSafeRadius}
                    stroke="white"
                    strokeWidth={2 / mapScale}
                />
            )}
        </Group>
    )
}

export const Safezone = props => <ZoneCircle {...props} color="white" />

export const Bluezone = props => <BlueZone {...props} />

export const Redzone = props => <ZoneCircle {...props} color="#FF000044" background="#FF000044" />


// WEBPACK FOOTER //
// src/components/MatchPlayer/Map/ZoneCircle.js